export class ActivationObject {
    securityToken = "";
    username = "";
    userType = 0;
    requestValue = ""; //<entitlement [guid]> or <product type [rt, mcrt, drtos-rt, drtos-mcrt, eval, etc...]> 
    requestType = ""; //entitlement, suac, login
    source = ""; //third party web service call, portal, licman, admin portal
    comment = "";
    fingerprint = "";
    force = false;
}